export default __webpack_public_path__ + "static/media/Res_Elastic-Load-Balancing_Application-Load-Balancer_48_Dark.b5f98a42.svg";